var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2690",
    "data-name": "Group 2690",
    transform: "translate(-419 -166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_home-trend-up",
    "data-name": "vuesax/linear/home-trend-up",
    transform: "translate(0 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-trend-up",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 188)",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_home-trend-up-2",
    "data-name": "vuesax/linear/home-trend-up",
    transform: "translate(-38.015 -46.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M8.012,20h-3.8A4.226,4.226,0,0,1,0,15.776V8.355A4.764,4.764,0,0,1,1.633,5.03L7.031.824A4.3,4.3,0,0,1,9.629,0a4.224,4.224,0,0,1,2.408.7L18.227,5.04A4.724,4.724,0,0,1,20.03,8.5v7.291A4.221,4.221,0,0,1,15.813,20h-3.8V17.007a2,2,0,0,0-4.006,0V20Z",
    transform: "translate(459 214.015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ddce253db6e25676f88555a6997f0879.svg";
export { ForwardRef as ReactComponent };